import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { ICustomerClinicmanagerPhoneResponse } from "@/api_framework/api_modals/Users";
import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { setClinicManagersMobile } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

import { useAPIUtils } from "../../useAPIUtils";
AxiosCurlirize(axios, () => {});
// returns new created addressID
export const useClinicManagerPhoneAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const user = useAppSelector((state) => state.auth.user);
  const email = user?.email;
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async (): Promise<string | null> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
      const requestHeaders = new Headers();
      requestHeaders.append("Authorization", `${accessToken}`);
      const response: string = await axios
        .get(`${CUSTOMER_APIS?.CLINICMANAGER_MOBILE?.baseURL}/${email}` ?? "", {
          headers: { Authorization: requestHeaders.get("Authorization") },
        })
        .then((res: AxiosResponse<ICustomerClinicmanagerPhoneResponse>) => {
          if (res.data.status === true) {
            dispatch(setClinicManagersMobile({ data: res.data.data }));
          } else {
            dispatch(setClinicManagersMobile({ data: null }));
            return null;
          }
        })
        .catch((e: AxiosError) => {
          // captureError(e);
          sendCurl(e.config["curlCommand"]);
          if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
            dispatch(setClinicManagersMobile({ data: null }));
          }
          return null;
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error. Please contact central team!");
      return null;
    }
    return null;
  }, []);
  return execute;
};
